import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../../context/CurrentUserContext';

/**
 * `/crm` index. Admin and operations land on Customers; anyone else the `/crm` guard let in
 * (sales) only has Partner Enquiries, so they land there
 * (YOJO-3371 [care-portal CRM page for partner enquiries]).
 */
export default function CrmIndexRedirect() {
  const { isAdmin, isOperations } = useCurrentUser();
  const target = isAdmin || isOperations ? '/crm/customers' : '/crm/partner-enquiries';
  return <Navigate to={target} replace />;
}
